APP.Chart = (/** @lends APP.Chart */function () {
	'use strict';

	var exports = {},
		idSeeker = 0,
		colors = {
			lightGrey: '#cccccc',
			grey: '#666666',
			blue: '#038cd6',
			green: '#43c682',
			yellow: '#febd11',
			red: '#fe635f'
		},

		pieChartOptions = {
			type: 'pie',
			labelText: '',
			balloonText: '',
			startDuration: 0.3,
			startEffect: 'easeOutSine',
			startRadius: '60%',
			startAlpha: 0,
			marginTop: 0,
			radius: '38%',
			innerRadius: '84%',
			pullOutOnlyOne: true,
			pullOutEffect: 'easeOutSine',
			pullOutRadius: '10%',
			pullOutDuration: 0.3,

			panEventsEnabled: false,
			pan: true,

			valueField: 'value',
			colorField: 'color',

			responsive: {
				enabled: true
			}
		},

		lineChartOptions = {
			units: 'Ft',
			type: 'serial',
			categoryField: 'x',
			marginRight: 10,
			startDuration: 0.5,
			columnWidth: 0.8,
			panEventsEnabled: false,
			pan: true,
			startEffect: 'easeOutSine',

			decimalSeparator: ' ',

			rotate: false,

			responsive: {
				enabled: true,
				rules: [
					{
						maxWidth: 640,
						overrides: {
							rotate: true
						}
					}

				]
			},

			valueAxes: [
				{
					minimum: 0,
					axisAlpha: 0.5,
					gridAlpha: 0.5,
					unit: ' Ft',
					labelFunction: function (label) {
						return formatNumber(label) + ' Ft';
					}
				}
			],
			categoryAxis: [
				{
					labelsEnabled: true,
					axisAlpha: 0.0,
					gridAlpha: 0.0
				}
			],

			graphs: [
				{
					type: 'column',
					valueField: 'y',
					lineColorField: 'color',
					fillColorField: 'color',
					colorField: 'color',
					alphaField: 'alpha',
					fillAlphas: 1,
					lineAlpha: 1.0,
					urlField: 'href',
					patternField: 'pattern',
					balloonText: '[[text]]',
					cornerRadiusTop: 2,
					bulletAlpha: 0,
					bulletBorderAlpha: 0,
					bulletOffset: -30,
					bulletSize: 20,
					bullet: 'none',
					labelText: '[[text]]'
				}
			]
		},

		pieChartHbs,

		$body;

	function init() {
		pieChartHbs = APP.Template.get('pie-chart');
		initDOMElements();
		initAllChart();
		setLineChartRotate();

		APP.Bind.click({
			'activize-chart-tab': function (event, tabIndex) {
				var $tab = $body.find('[data-element="chart-tab-1"]');

				$tab.attr('data-tab-active', $tab.attr('data-tab-active') === tabIndex ? 0 : tabIndex);
			}
		});

		$(window).on('resize', setLineChartRotate);

	}

	function setLineChartRotate() {
		lineChartOptions.rotate = $(window).width() <= 640;
	}

	function formatNumber(x) {
		if (isNaN(x)) {
			return x;
		}

		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
	}

	function initAllChart() {
		var $this,
			data;

		initPieCharts($body);

		$body.find('[data-line-chart]:not(.line-chart-tab__chart)').each(function () {
			$this = $(this);

			data = window.parseJSON($this.attr('data-line-chart'));

			if (data) {
				lineChart($this, data);
			}
		});

		$body.find('[data-line-chart-tab]').each(function () {
			$this = $(this);
			lineChartTab($this, 1000);
		});

	}

	function initDOMElements() {
		$body = APP.Performance.getCachedDOM().$body;
	}

	function initPieCharts($wrapper) {
		$wrapper.find('[data-pie-chart]:not([data-pie-chart-initialized])').each(function () {
			var $this = $(this),
				data = window.parseJSON($this.attr('data-pie-chart'));

			if (data) {
				$this.attr('data-pie-chart-initialized', true);
				pieChart($this, data);
			}
		});
	}

	function pieChart($element, propertyes, inverse) {
		var id = 'chart-element-' + (idSeeker += 1),
			options = $.extend({}, pieChartOptions),
			data = [
				{
					value: propertyes.phases[inverse ? 0 : 1].value,
					color: colors[propertyes.color]
				},
				{
					value: propertyes.all - propertyes.phases[inverse ? 0 : 1].value,
					color: colors.lightGrey
				}
			],
			chart;


		if (propertyes.unknownQuota) {
			options.radius = '38%';
			options.innerRadius = '95%';
			data[0].value = 0;
			data[1].color = colors.blue;
			data[1].value = propertyes.phases[0].value === 0 ? 1 : propertyes.phases[0].value;
		}

		$element.html(pieChartHbs({
			label: propertyes.phases[inverse ? 0 : 1],
			inverse: !!inverse,
			unknownQuota: !!propertyes.unknownQuota,
			id: id,
			index: window.parseInt(propertyes.index, 10) + 1,
			idNumber: idSeeker
		}));


		options.dataProvider = data;
		chart = new window.AmCharts.makeChart(id, options);

		if (!propertyes.unknownQuota) {
			$element.off('click.pieChart');
			$element.on('click.pieChart', function () {
				pieChart($element, propertyes, !inverse);
			});
		}

		return chart;

	}

	function lineChart($element, data) {
		var id = 'chart-element-' + (idSeeker += 1),
			options = $.extend({}, lineChartOptions),
			chart,
			i;

		for (i = 0; i < data.length; i++) {
			data[i].color = colors[data[i].color];
			data[i].text = data[i].val;
			data[i].x = data[i].label;
			data[i].bulletColor = '#FFFFFF';
		}

		options.dataProvider = data;
		$element.attr('id', id);
		chart = new window.AmCharts.makeChart(id, options);
		chart.balloon.borderColor = '#000000';
		chart.balloon.borderAlpha = 0.3;
		chart.balloon.borderThickness = 1;
		chart.balloon.fillAlpha = 1;
		chart.balloon.color = '#333333';
		return chart;
	}

	function lineChartTab($element, index) {
		var $chart = $element.find('[data-line-chart]'),
			data,
			activeIndex = index || parseInt($element.attr('data-line-chart-tab'), 10) || 1000,
			i, j, k,
			buttonsHtml = '',
			buttonsStyle,
			$amChart,
			amChartWidth,
			colspan;

		if (typeof $chart.attr('data-line-chart') === 'undefined' || $chart.attr('data-line-chart') === '') {
			return false;
		}

		data = window.parseJSON($chart.attr('data-line-chart'));

		buttonsStyle = generateStyleSheet(data.length);

		for (i = 1; i < data.length + 1; i++) {
			if (activeIndex === i) {
				data[i - 1].color = 'blue';
				colspan = data[i - 1].colspan;
				if (colspan > 0) {
					buttonsHtml = addButton(buttonsHtml, colspan, true, i);

					if (colspan > 1) {
						for (k = 1; k < colspan; k++) {
							buttonsStyle += 'svg g[cursor="pointer"]:nth-child(' + (i + k) + ') { cursor:pointer !important; }';
						}
					}

					for (j = i - 1; j < i + data[i - 1].colspan - 1; j++) {
						data[j].color = 'blue';
						data[j].href = createJsHref(i);
					}

					i = j;
				} else {
					buttonsHtml = addButton(buttonsHtml, false, true, i);
				}
			} else {
				data[i - 1].color = 'green';
				if (data[i - 1].colspan > 0) {
					buttonsHtml = addButton(buttonsHtml, data[i - 1].colspan, false, i);
					for (j = i - 1; j < i + data[i - 1].colspan - 1; j++) {
						data[j].href = createJsHref(i);
					}

				}

				if (!data[i - 1].href) {
					buttonsHtml = addButton(buttonsHtml, false, false, i);
					data[i - 1].href = createJsHref(i);
				}

			}

		}

		$body.find('[data-line-chart-buttons]').html(buttonsHtml);
		$body.find('[data-line-chart-style]').html(buttonsStyle);
		$amChart = $body.find('.amcharts-chart-div');

		if ($amChart.length > 0) {
			if ($amChart.find('svg > g > path:nth-child(2)').length > 0) {
				amChartWidth = parseInt($amChart.find('svg > g > path:nth-child(2)')[0].getBoundingClientRect().width, 10);
			} else {
				amChartWidth = parseInt($amChart.find('svg > g > path')[0].getBoundingClientRect().width, 10);
			}
			$body.find('[data-line-chart-buttons]').css({marginLeft: 0, paddingLeft: $amChart.width() - amChartWidth - 10});
		}

		lineChart($chart, data);
	}

	function generateStyleSheet(columns) {
		return '.line-chart-tab__button {width:' + getColumnWidth(columns, 1) + '%}' +
			'.line-chart-tab__button--2 {width:' + getColumnWidth(columns, 2) + '%}' +
			'.line-chart-tab__button--3 {width:' + getColumnWidth(columns, 3) + '%}' +
			'.line-chart-tab__button--4 {width:' + getColumnWidth(columns, 4) + '%}';
	}

	function getColumnWidth(columns, count) {
		return 100 / columns * count;
	}

	function addButton(htmlText, colspan, active, i) {
		var classes = ['line-chart-tab__button', 'tab-' + i];

		if (colspan) {
			classes.push('line-chart-tab__button--' + colspan);
		}

		if (active) {
			classes.push('line-chart-tab__button--active');
		}

		return htmlText + '<div class="' + classes.join(' ') + '"><a href="' + createJsHref(i) + '" class="button button--small button--nth-' + i + '">Részletek</a></div>';

	}

	function createJsHref(i) {
		return 'javascrip' + 't:APP.Chart.changeLineChartTab(\'chart-element-' + (idSeeker + 1) + '\',\'' + i + '\')';
	}

	function changeLineChartTab(chartId, rawLineIndex, isForced) {
		var lineIndex = parseInt(rawLineIndex, 10),
			$lineChartTab = $(document.getElementById(chartId)).parents('[data-line-chart-tab]').first(),
			index = lineIndex;

		if (lineIndex < 3 || lineIndex === 5) {
			if ($body.find('.line-chart-tab__button--' + (parseInt(index, 10) + 1) + ' .button').css('visibility') !== 'hidden') {
				if (parseInt($lineChartTab.attr('data-line-chart-tab'), 10) === index && isForced !== true) {
					index = 1000;
				}
				$lineChartTab.attr('data-line-chart-tab', index);
				lineChartTab($lineChartTab, parseInt(index, 10));
			}

		}
	}

	exports.init = init;
	exports.pieChart = pieChart;
	exports.lineChart = lineChart;
	exports.lineChartTab = lineChartTab;
	exports.changeLineChartTab = changeLineChartTab;
	exports.getId = function () {
		return idSeeker;
	};

	return exports;

}());
